import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Department } from './types/department.type';

/**
 * Fetches a single department, including the roles it bundles.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the department.
 * @returns OperationResultWithData wrapping `Department`.
 */
export const getDepartment = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.get<OperationResultWithData<Department>>(formatString(Uri.departments.byUid, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
